const breakpointToMinPxMapping = {
    small: 0,
    medium: 768,
    large: 1024,
};
const breakpointList = Object.keys(breakpointToMinPxMapping);
const isPropByBreakpoint = (value) => {
    return (typeof value === 'object' &&
        value !== null &&
        breakpointList.includes(Object.keys(value)[0]));
};
export const resolveResponsiveProp = (value, styleTemplate) => {
    if (!isPropByBreakpoint(value)) {
        return `
      @media (min-width: ${breakpointToMinPxMapping.small}px) {
        ${styleTemplate(value)}
      }
    `;
    }
    const breakpointUsed = Object.keys(value);
    let style = '';
    breakpointUsed.forEach((breakpoint) => {
        style += `
        @media (min-width: ${breakpointToMinPxMapping[breakpoint]}px) {
          ${styleTemplate(value[breakpoint])}
        }
      `;
    });
    return style;
};
//# sourceMappingURL=responsiveProp.js.map